import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext } from '../ModalContext'
import { ClockIcon } from '@heroicons/react/24/outline'
import { GetPrimaryColorHex } from 'redux/slices/brand'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function WorkoutLengthSelectionModal() {

    const workoutLengthOptions = [30, 40, 60]

    const { modalData, HideModal } = useContext(ModalContext)
    
    const styleConfig = useSelector((state) => state.brand.styleConfig)

    const [selectedWorkoutLength, setSelectedWorkoutLength] = useState(modalData.selectedWorkoutLength)
    const [setAsDefaultWorkoutLength, setSetAsDefaultWorkoutLength] = useState(false)
    const [isSavingDefaultWorkoutLength, setIsSavingDefaultWorkoutLength] = useState(false)

    const OnSaveButton = async (workoutLength) => {

        // If setting as default workout length, save to backend

        if (setAsDefaultWorkoutLength) {

            if (modalData.profileType === 'group') {

                setIsSavingDefaultWorkoutLength(true)

                const jsonBody = {
                    groupId: modalData.groupId,
                    defaultWorkoutLength: selectedWorkoutLength
                }

                // console.log(jsonBody);

                const result = await WhichWeightAPI('REPORTING', 'POST', '/group_default_workout_length', jsonBody)

                // console.log(result);

                if (result.data.status === 'failure') {
                    console.error(result);
                    setIsSavingDefaultWorkoutLength(false)
                    return
                }

                setIsSavingDefaultWorkoutLength(false)

            }

            if (modalData.profileType === 'individual') {
            
                setIsSavingDefaultWorkoutLength(true)

                const jsonBody = {
                    userId: modalData.athleteId,
                    defaultWorkoutLength: selectedWorkoutLength
                }

                // console.log(jsonBody);

                const result = await WhichWeightAPI('CORE', 'POST', '/default_workout_length', jsonBody)

                // console.log(result);

                if (result.data.status === 'failure') {
                    console.error(result);
                    setIsSavingDefaultWorkoutLength(false)
                    return
                }

                setIsSavingDefaultWorkoutLength(false)

            }

        }

        modalData.setSelectedWorkoutLength(workoutLength)
        
        HideModal()
    }

    return (
        <>
            <div 
                className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full"
                style={{
                    backgroundColor: GetPrimaryColorHex(styleConfig),
                }}
            >
                <ClockIcon className="h-8 w-8 text-white" aria-hidden="true" />
            </div>

            <div className='space-y-2'>
                <h1 className='text-center'>Workout Length</h1>
                <p className='text-center text-sm'>How long do you want to workout for?</p>
            </div>

            {/* Workout Length Options */}

            <div className='items-center rounded-xl text-center bg-gray-100 rounded-xl overflow-hidden'>
                {workoutLengthOptions.map((workoutLength) => (
                    <div 
                        key={workoutLength}
                        className={`
                            h-12 flex items-center justify-center
                            ${selectedWorkoutLength === workoutLength ? 'text-white font-bold' : 'text-gray-500'}
                        `}
                        style={{ backgroundColor: selectedWorkoutLength === workoutLength ? GetPrimaryColorHex(styleConfig) : '' }}
                        onClick={() => setSelectedWorkoutLength(workoutLength)}
                    >
                        {workoutLength} minutes
                    </div>
                ))}
            </div>

            {/* Set as default workout length toggle */}

            <div 
                className="flex items-center justify-between rounded-xl p-4 bg-gray-100 gap-x-2"
                onClick={() => setSetAsDefaultWorkoutLength(!setAsDefaultWorkoutLength)}
            >
                <label className="text-gray-500">Set as default workout length</label>

                <div>
                    <div 
                        className='w-12 h-6 rounded-full p-0.5 transition-colors duration-200 ease-in-out'
                        style={{
                            backgroundColor: setAsDefaultWorkoutLength ? GetPrimaryColorHex(styleConfig) : '#e5e7eb'
                        }}
                    >
                        <div 
                            className={`
                                w-5 h-5 rounded-full bg-white transform transition-transform duration-200 ease-in-out 
                                ${setAsDefaultWorkoutLength ? 'translate-x-6' : 'translate-x-0'}
                            `}
                        />
                    </div>
                </div>
            </div>

            {/* Save button */}

            <BrandColorButton 
                text="Save" 
                action={() => OnSaveButton(selectedWorkoutLength)} 
                isLoading={isSavingDefaultWorkoutLength}
            />

        </>
    )
}
